import React, {useRef, useEffect, useState} from 'react'
import classes from './ambientBackground.module.scss'
import {useMediaQuery} from 'react-responsive';
import { getFileName } from '../../../../../helpers/FileCaching';

const AmbientImages = require.context('../../../../../images/components/Introduction/video_posters', true, /.*\.(gif|png|jpe?g|svg)$/i);

function AmbientBackground({content, isActive, shouldPreload, videoCdnUrl}){

    let videoBackground = useRef(null)
    let [screenSize, setScreenSize] = useState("mobile")
    let [hasPreloaded, setHasPreloaded] = useState(false)

    const isDesktop = useMediaQuery({
        query: `(min-width: ${classes.screenMd})`
    })

    const isTablet = useMediaQuery({
        query: `(min-width: ${classes.screenSm})`
    })
    
    useEffect(() =>{

        let size = "mobile"

        if(isTablet)
            size = "tablet";

        if(isDesktop)
            size = "desktop";

        setScreenSize(size)
    }, [isDesktop,isTablet])

    useEffect(() =>{
        if(shouldPreload){
            setHasPreloaded(true)
        }
    },[shouldPreload])
    
    useEffect(() =>{

		if(videoBackground.current != null){
			if(videoBackground.current.currentTime > 0 ){
				onBackgroundVideoStart()
			}else{
				videoBackground.current.addEventListener("play", onBackgroundVideoStart)
			}
		}

    },[hasPreloaded])

    useEffect(() =>{
        if(videoBackground.current != null){
            if(isActive){
                videoBackground.current.play()
                if(videoBackground.current.currentTime > 0 ){
                    onBackgroundVideoStart()
                }
            }else{
                videoBackground.current.pause()
            }
        }
    },[isActive])

    useEffect(() => {

		if(videoBackground.current != null){
			if(videoBackground.current.currentTime > 0 ){
				onBackgroundVideoStart()
			}else{
				videoBackground.current.addEventListener("play", onBackgroundVideoStart)
			}
		}

	},[screenSize])

    function onBackgroundVideoStart(){

		videoBackground.current.classList.add(classes['AmbientBackground__inlineVideo--active'])

	}

	return (

        <div 
            className={classes.AmbientBackground__videoContainer}
            style={
            {
                backgroundImage: `url(${getFileName(AmbientImages, content[screenSize].poster)})`
            }
        }>
            <div className={`${classes.AmbientBackground__overlay}`} ></div>
            <div className={`${classes.AmbientBackground__inlineVideoWrapper}`}>
                {(
                    hasPreloaded 
                    ?
                    <video ref={(ref) => {videoBackground.current = ref}} className={classes.AmbientBackground__inlineVideo} playsInline autoPlay loop muted src={`${videoCdnUrl}${content[screenSize].videoSrc}`}/> 
                    :
                    ""
                )}
                
            </div>
        </div>

	)
}

export default AmbientBackground